import type { RouteLocationNormalizedGeneric } from "vue-router";

import { CancelError } from "@/error/CancelError";
import { captureException } from "@/error/sentry";

export function logError(
  error: unknown,
  to: RouteLocationNormalizedGeneric,
  from: RouteLocationNormalizedGeneric,
) {
  if (!(error instanceof CancelError)) {
    captureException(error, { navigation: { from: from.fullPath, to: to.fullPath } });
  }
}
